import React from "react";

import type { ActionType } from "@calcom/ui";
import {
  Button,
  ButtonGroup,
  Dropdown,
  DropdownItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Tooltip,
} from "@calcom/ui";
import { Video, MoreHorizontal } from "@calcom/ui/components/icon";
import type { BookingItemProps } from "@calcom/web/components/booking/BookingListItem";

type BookingItemActionsInfoProps = {
  booking: BookingItemProps;
  menuItems: ActionType[];
  videoMeetingUrl?: string;
};

function BookingItemActions({ booking, menuItems, videoMeetingUrl }: BookingItemActionsInfoProps) {
  return (
    <span onClick={(e) => e.stopPropagation()}>
      <ButtonGroup combined>
        {videoMeetingUrl && (
          <Tooltip content="Join meeting application">
            <Button
              color="secondary"
              variant="icon"
              className="max-w-8 bg-blue-500"
              href={`/meeting?meetingUrl=${encodeURIComponent(videoMeetingUrl)}&bookingId=${booking.id}`}
              StartIcon={Video}
            />
          </Tooltip>
        )}
        {Array.isArray(menuItems) && menuItems.length === 0 ? null : (
          <Dropdown modal={false}>
            <DropdownMenuTrigger asChild className="radix-state-open:rounded-r-md">
              <Button type="button" variant="icon" color="secondary" StartIcon={MoreHorizontal} />
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              {menuItems.map((item) => (
                <DropdownMenuItem key={item.id}>
                  <DropdownItem type="button" StartIcon={item.icon} onClick={item.onClick}>
                    {item.label}
                  </DropdownItem>
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </Dropdown>
        )}
      </ButtonGroup>
    </span>
  );
}

export default BookingItemActions;
